module.exports = {
  loginRedirect: process.env.REACT_APP_LOGIN_REDIRECT,
  apiUrl: process.env.REACT_APP_API_URL
}

